<template>
  <div class="columns is-multiline is-mobile">
    <div class="column">
      <window title='Drag &amp; Drop <a href="https://github.com/SortableJS/Vue.Draggable"
                                        target="_blank">(more info)</a>'>
        <div class="columns">
          <div class="drag column">
            <div class="list">
              <span class="list-name is-primary">Group A</span>
              <draggable v-model="list" class="dragArea" :options="{group:'people'}">
                <div class="list-element" v-for="(element, index) in list" v-bind:key="index">
                  <div class="columns is-gapless">
                    <div class="column is-narrow">
                      <i class="fas fa-arrows-alt"></i>
                    </div>
                    <div class="column">
                      <span>{{element.name}}</span>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="drag column">
            <div class="list">
              <span class="list-name is-primary">Group B</span>
              <draggable v-model="list2" class="dragArea" :options="{group:'people'}">
                <div class="list-element" v-for="(element, index) in list2" v-bind:key="index">
                  <div class="columns is-gapless">
                    <div class="column is-narrow">
                      <i class="fas fa-arrows-alt"></i>
                    </div>
                    <div class="column">
                      <span>{{element.name}}</span>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
          <div class="drag column">
            <div class="list">
              <span class="list-name is-primary">Group C</span>
              <draggable v-model="list3" class="dragArea" :options="{group:'people'}">
                <div class="list-element" v-for="(element, index) in list3" v-bind:key="index">
                  <div class="columns is-gapless">
                    <div class="column is-narrow">
                      <i class="fas fa-arrows-alt"></i>
                    </div>
                    <div class="column">
                      <span>{{element.name}}</span>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </window>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  components: { draggable },
  data() {
    return {
      list: [{
        name: 'John',
      }, {
        name: 'Joao',
      }, {
        name: 'Jean',
      }],
      list2: [{
        name: 'Juan',
      }, {
        name: 'Edgard',
      }, {
        name: 'Johnson',
      }],
      list3: [{
        name: 'Michael',
      }, {
        name: 'Eduard',
      }, {
        name: 'James',
      }],
    };
  },
  methods: {
    add() {
      this.list.push({
        name: 'Juan',
      });
    },
    replace() {
      this.list = [{
        name: 'Edgard',
      }];
    },
  },
};
</script>

<style lang="scss" scoped>
.drag {
  .list {
    background-color: #f9f9f9;
    padding-bottom: 20px;
    &-element {
      border: 1px solid #ccc;
      margin: 2px 0px;
      padding: 5px;
      background-color: #ffffff;
      i,
      span {
        padding: 5px;
      }
      &:hover {
        cursor: grab;
      }
      &:active {
        cursor: grabbing;
      }
    }
    &-name {
      padding: 7px;
    }
  }
  .dragArea {
    min-height: 40px;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    &:empty {
      border: 2px dashed #aaa;
    }
  }
}
</style>
